import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-end gap-2" }
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: $props.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    modal: "",
    header: "Select lesson to add"
  }, {
    default: _withCtx(() => [
      (_ctx.lessons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_DataTable, {
              value: _ctx.lessons,
              rows: 10,
              paginator: "",
              dataKey: "id",
              tableStyle: "min-width: 50rem",
              sortField: "createdAction.timestamp",
              sortOrder: -1,
              globalFilterFields: ['title'],
              filters: $data.filters,
              "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (($data.filters) = $event)),
              onRowClick: $options.onRowClicked
            }, {
              empty: _withCtx(() => [
                _createTextVNode("No lessons found.")
              ]),
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_InputText, {
                      modelValue: $data.filters['global'].value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.filters['global'].value) = $event)),
                      placeholder: "Keyword Search"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fa fa-refresh",
                    class: "p-button-secondary",
                    rounded: "",
                    raised: "",
                    onClick: $options.refreshTable
                  }, null, 8, ["onClick"])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "title",
                  header: "Title",
                  sortable: "",
                  searchable: ""
                }),
                _createVNode(_component_Column, {
                  header: "Image",
                  class: "min-w-[148px]"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("img", {
                      src: data.imageUrl,
                      class: "w-32 drop-shadow-xl rounded-md"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "createdAction.timestamp",
                  header: "Created",
                  dataType: "date",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(data.createdAction?.timestamp)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "filters", "onRowClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}